/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetShopConfigResponse } from '../models/get-shop-config-response';
import { GetTableMetadataResponse } from '../models/get-table-metadata-response';
import { GetTableMetadataRequest } from '../models/get-table-metadata-request';
@Injectable({
  providedIn: 'root',
})
class ShopConfigService extends __BaseService {
  static readonly getApiShopConfigPath = '/api/ShopConfig';
  static readonly postApiShopConfigGetTableMetadataPath = '/api/ShopConfig/GetTableMetadata';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  getApiShopConfigResponse(): __Observable<__StrictHttpResponse<GetShopConfigResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ShopConfig`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetShopConfigResponse>;
      })
    );
  }
  /**
   * @return Success
   */
  getApiShopConfig(): __Observable<GetShopConfigResponse> {
    return this.getApiShopConfigResponse().pipe(
      __map(_r => _r.body as GetShopConfigResponse)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  postApiShopConfigGetTableMetadataResponse(body?: GetTableMetadataRequest): __Observable<__StrictHttpResponse<GetTableMetadataResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/ShopConfig/GetTableMetadata`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetTableMetadataResponse>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postApiShopConfigGetTableMetadata(body?: GetTableMetadataRequest): __Observable<GetTableMetadataResponse> {
    return this.postApiShopConfigGetTableMetadataResponse(body).pipe(
      __map(_r => _r.body as GetTableMetadataResponse)
    );
  }
}

module ShopConfigService {
}

export { ShopConfigService }
